import Vue from 'vue'
import Router from 'vue-router'
import { isRetailContext } from '@invivodf/common/src/application/composables/useContext'
import routerBeforeEach from './hooks/beforeEach'
import { getB2agRoutes } from './router-b2ag'
import { getRetailRoutes } from './router-retail'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: isRetailContext() ? getRetailRoutes(() => router) : getB2agRoutes(() => router),
})

router.beforeEach(routerBeforeEach)

export const getRouter = () => router

export default router
